// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2LQiy","title":"Header_title__2cKty","left":"Header_left__HU-Mo","clinicName":"Header_clinicName__bAOKm"};